import React from "react";
// react plugin used to create google maps
import tt from "../../assets/img/tt.png"

// import {
//   withScriptjs,
//   withGoogleMap,
//   GoogleMap,
//   Marker,
// } from "react-google-maps";
// // reactstrap components
import { Button, Form, Input, Container, Row, Col } from "reactstrap";
import Particles from "components/Particles.js";

// core components
import InfoNavbar from "components/Navbars/InfoNavbar.js";
import FooterBlack from "components/Footers/FooterBlack.js";
import Buttons from "../../components/Headers/Buttons.js";
import { useTranslation } from 'react-i18next';

// const MapWrapper = withScriptjs(
//   withGoogleMap((props) => (
//     <GoogleMap
//       defaultZoom={14}
//       defaultCenter={{ lat: 44.445248, lng: 26.099672 }}
//       defaultOptions={{
//         styles: [
//           {
//             featureType: "water",
//             elementType: "geometry",
//             stylers: [
//               {
//                 color: "#e9e9e9",
//               },
//               {
//                 lightness: 17,
//               },
//             ],
//           },
//           {
//             featureType: "landscape",
//             elementType: "geometry",
//             stylers: [
//               {
//                 color: "#f5f5f5",
//               },
//               {
//                 lightness: 20,
//               },
//             ],
//           },
//           {
//             featureType: "road.highway",
//             elementType: "geometry.fill",
//             stylers: [
//               {
//                 color: "#ffffff",
//               },
//               {
//                 lightness: 17,
//               },
//             ],
//           },
//           {
//             featureType: "road.highway",
//             elementType: "geometry.stroke",
//             stylers: [
//               {
//                 color: "#ffffff",
//               },
//               {
//                 lightness: 29,
//               },
//               {
//                 weight: 0.2,
//               },
//             ],
//           },
//           {
//             featureType: "road.arterial",
//             elementType: "geometry",
//             stylers: [
//               {
//                 color: "#ffffff",
//               },
//               {
//                 lightness: 18,
//               },
//             ],
//           },
//           {
//             featureType: "road.local",
//             elementType: "geometry",
//             stylers: [
//               {
//                 color: "#ffffff",
//               },
//               {
//                 lightness: 16,
//               },
//             ],
//           },
//           {
//             featureType: "poi",
//             elementType: "geometry",
//             stylers: [
//               {
//                 color: "#f5f5f5",
//               },
//               {
//                 lightness: 21,
//               },
//             ],
//           },
//           {
//             featureType: "poi.park",
//             elementType: "geometry",
//             stylers: [
//               {
//                 color: "#dedede",
//               },
//               {
//                 lightness: 21,
//               },
//             ],
//           },
//           {
//             elementType: "labels.text.stroke",
//             stylers: [
//               {
//                 visibility: "on",
//               },
//               {
//                 color: "#ffffff",
//               },
//               {
//                 lightness: 16,
//               },
//             ],
//           },
//           {
//             elementType: "labels.text.fill",
//             stylers: [
//               {
//                 saturation: 36,
//               },
//               {
//                 color: "#333333",
//               },
//               {
//                 lightness: 40,
//               },
//             ],
//           },
//           {
//             elementType: "labels.icon",
//             stylers: [
//               {
//                 visibility: "off",
//               },
//             ],
//           },
//           {
//             featureType: "transit",
//             elementType: "geometry",
//             stylers: [
//               {
//                 color: "#f2f2f2",
//               },
//               {
//                 lightness: 19,
//               },
//             ],
//           },
//           {
//             featureType: "administrative",
//             elementType: "geometry.fill",
//             stylers: [
//               {
//                 color: "#fefefe",
//               },
//               {
//                 lightness: 20,
//               },
//             ],
//           },
//           {
//             featureType: "administrative",
//             elementType: "geometry.stroke",
//             stylers: [
//               {
//                 color: "#fefefe",
//               },
//               {
//                 lightness: 17,
//               },
//               {
//                 weight: 1.2,
//               },
//             ],
//           },
//         ],
//         scrollwheel: false, //we disable de scroll over the map, it is a really annoing when you scroll through page
//       }}
//     >
//       <Marker position={{ lat: 44.445248, lng: 26.099672 }} />
//     </GoogleMap>
//   ))
// );


const lngs = {
  en: { nativeName: 'English' },
  es: { nativeName: 'Spanish' }
};
function ContactUs() {
  const { t, i18n } = useTranslation();
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("contact-page");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("contact-page");
    };
  });
  return (
    <>

      <InfoNavbar />
      <br/>
      <Buttons/>
      <div style={{height:"3px", backgroundColor: "gold"}} />

      <div className="main">
        <div className="section section-gray">
          <Container>
          <Particles />

            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <h2 className="title">{t('description.part30')}</h2>
                <p>
                Avenida San Martín Cra. 5 1ª# 5-241 Local 9<br/>
Centro Comercial Michell Center<br/>
Barrio Bocagrande<br/>
                </p>
              </Col>
            </Row>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="6">
                <h3 className="title" href="tel:573006572717">
                <small >
                (+57) 300-657-2717</small></h3><a href="mailto:btcartagenaonline@gmail.com" target="_blank"><h3><small>
                btcartagenaonline@gmail.com</small>
                </h3></a>
                <br/>
            
                <Button className="btn-just-icon mr-1" color="facebook">
                  <i className="fa fa-facebook" />
                </Button>
              
                <Button
                                      className="btn-just-icon btn-round mr-1"
                                      color="dribble"
                                      href="https://www.tiktok.com/@btcartagenaonline"
                                    >
                  <center>  <img src={tt} style={{height:"25px"}} /></center>
                </Button>
                <Button href="https://www.instagram.com/btcartagenaonline" className="btn-just-icon mr-1" color="instagram">
                  <i  className="fa fa-instagram" />
                </Button>
              
              </Col>
            </Row>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="6">
                <h3 className="title">
                  <small>{t('description.part31')}</small>
                </h3>
                <Form
                      className="p-3"
                      action="https://postmail.invotes.com/send"
                      method="post"
                      id="contact_form"
                      role="form"
                    >
                          <input
                      type="hidden"
                      name="access_token"
                      value="j5gyyeo86ing8s64kdbswki3"
                    />
                      <input
                      type="hidden"
                      name="success_url"
                      value=".?message=Email+Successfully+Sent%21&isError=0"
                    />
                    <input
                      type="hidden"
                      name="error_url"
                      value=".?message=Email+could+not+be+sent.&isError=1"
                    />
                  <Row>
                    <Col md="12">
                      <Input placeholder="Full Name" type="text"  name="subject" />
                    </Col>
                   
                  </Row>
                  <Row>
                    <Col md="6">
                      <Input placeholder="Email" type="text" name="text" />
                    </Col>
                    <Col md="6">
                      <Input placeholder="Subject" type="text" name="extra_subject" />
                    </Col>
                  </Row>
                  <Input placeholder="Message" rows="7" type="textarea" name="extra_Message" />
                  <Row>
                    <Col className="ml-auto mr-auto" md="6">
                    <input
                      type="hidden"
                      name="access_token"
                      value="fmin2luwi0f9iujitblnnpr6"
                    />
                      <Button block className="btn-round" color="primary" type="submit" id="submit_form">
                        Send
                      </Button>
                    </Col>
                  </Row>
                </Form>
                <h3 className="visit">
                  <small>{t('description.part32')}</small>
                </h3>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div className="big-map" id="contactUsMap">
      <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d15488.783192862846!2d-75.55810179188009!3d10.40324754082633!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sCentro%20Comercial%20Mitchell%20Center%20cartagena!5e0!3m2!1sen!2sus!4v1726663813949!5m2!1sen!2sus" width="100%" height="100%"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
 
      </div>
      <FooterBlack />
    </>
  );
}

export default ContactUs;
